(function () {
  /**
   * @ngdoc module
   * @name akitabox.mobile.directives.buildingInput
   */
  angular
    .module("akitabox.mobile.directives.buildingInput", [
      "akitabox.core.services.building",
    ])
    .directive("abmBuildingInput", AbmBuildingInputDirective);

  /**
   * @ngdoc directive
   * @module akitabox.mobile.directives.buildingInput
   * @name AbmBuildingInputDirective
   * @restrict E
   * @description
   * `abm-building-input` creates 3 select dropdown menus to allow for building saving
   */
  /* @ngInject */
  function AbmBuildingInputDirective() {
    return {
      restrict: "E",
      templateUrl: "app/mobile/directives/building-input/building-input.html",
      transclude: true,
      controller: AbmBuildingInputController,
      controllerAs: "vm",
      bindToController: true,
      link: postLink,
      scope: {
        inputId: "@?abmInputId",
        inputName: "@?abmInputName",
        account: "=",
        placeholder: "@?",
        ngModel: "=",
        ngChange: "&?",
      },
    };

    function postLink($scope, $element, attrs, vm) {
      vm.required = angular.isDefined(attrs.required);
      vm.requiresCreatePermission = angular.isDefined(
        attrs.requiresCreatePermission
      );
    }
  }

  /* @ngInject */
  function AbmBuildingInputController(
    $log,
    BuildingService,
    OrganizationService,
    ToastService
  ) {
    var self = this;

    if (angular.isUndefined(self.ngModel)) {
      return $log.error("<abm-building-input> ng-model is unassigned");
    } else if (angular.isUndefined(self.account)) {
      return $log.error("<abm-building-input> account is unassigned");
    }

    self.isDisabled = isDisabled;
    self.querySearch = querySearch;
    self.onChange = onChange;

    self.loading = false;
    self.searchText = null;
    self.placeholder = self.placeholder || "Choose a building";
    self.organization = OrganizationService.getCurrent();

    function isDisabled() {
      return !self.account;
    }

    function querySearch(searchText) {
      self.loading = true;

      return BuildingService.getAllByOrganization(self.organization._id)
        .then(function (buildings) {
          if (angular.isEmpty(searchText)) {
            return buildings;
          }
          return filterQuery(searchText, buildings);
        })
        .catch(ToastService.showError)
        .finally(function () {
          self.loading = false;
        });
    }

    function filterQuery(searchText, matches) {
      return matches.filter(function (match) {
        return match.name.match(new RegExp(searchText, "i"));
      });
    }

    function onChange(item) {
      if (angular.isFunction(self.ngChange)) {
        self.ngChange({ value: item });
      }
    }
  }
})();
